const component = "planning-date-range-header-cell";

export const planningDateRangeHeaderCell = {
  component,
  quarterMonthItem: `${component}/quarter/month-item`,
  monthDayItem: `${component}/month/day-item`,
  weekDayItem: `${component}/week/day-item`,
};
